<button type="button" class="btn user-btn user-button-more"
        *ngIf="isOpenedFromList && localUser.accessType !== AccessType.OBSERVER"
        placement="right"
        [ngbPopover]="userMoreOptions"
        title="More"
        [autoClose]="'outside'"
        popoverClass="cs-popover multilevel">
  <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
</button>
<button type="button" class="video-action-btn"
        *ngIf="!isOpenedFromList && localUser.accessType !== AccessType.OBSERVER"
        placement="auto"
        [ngbPopover]="userMoreOptions"
        title="More"
        [autoClose]="'outside'"
        popoverClass="cs-popover multilevel">
  <i class="fas fa-ellipsis-v"></i>
</button>

<ng-template #userMoreOptions>
  <div class="userMoreOptions-popover"
       [ngClass]="{'first-line': ((!classroom.isStudentsSectionCollapsed && userIndex < 6) || (classroom.isStudentsSectionCollapsed && userIndex < 8)) && !isOpenedFromList}">

    <div class="btn-group dropdown" dropdown #dropdown="bs-dropdown" [isOpen]="status.isOpenRedirect" autoClose="autoClose" [insideClick]="true">
      <button type="button" class="button redirect-button" title="Redirect Student to classroom" dropdownToggle>
      </button>
      <div class="dropdown-menu" *dropdownMenu>
        <div class="" style="padding: 3px">
          <form (ngSubmit)="redirectStudent()" ngNativeValidate>
            <div class="input-group">
              <input type="number" class="form-control number-input-without-arrow " onClick="event.stopPropagation()"
                     name="classroomNumber" [(ngModel)]="classroomNumber" [required]="true" min="100" max="9999">
              <div class="input-group-append">
                <button class="btn btn-default m-0" (click)="status.isOpenRedirect = true" type="submit">Redirect</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="btn-group dropdown" dropdown #dropdown="bs-dropdown" [isOpen]="status.isOpenFrameRate"
         *ngIf="showFrameRateAndVideoResolutionChangeButtons">
      <button type="button" class="button frame-rate-button" title="Set video frame rate" dropdownToggle></button>
      <div class="dropdown-menu" *dropdownMenu>
        <a class="dropdown-item" *ngFor="let rate of ['6','12','24']" (click)="setFrameRate(rate)">{{rate}}</a>
      </div>
    </div>

    <div class="btn-group dropdown" dropdown #dropdown="bs-dropdown" [isOpen]="status.isOpenVideoResolution"
         *ngIf="showFrameRateAndVideoResolutionChangeButtons">
      <button type="button" class="button video-resolution-button" title="Set video resolution" dropdownToggle></button>
      <div class="dropdown-menu" *dropdownMenu>
        <a class="dropdown-item" *ngFor="let resolution of ['240x180','320x240','640x480']"
           (click)="setResolution(resolution)">{{resolution}}</a>
      </div>
    </div>

    <div class="btn-group dropdown" dropdown #dropdown="bs-dropdown" [isOpen]="status.isOpenUserActions">
      <button type="button" class="button user-actions-button" title="Reload / Expel" dropdownToggle></button>
      <div class="dropdown-menu" *dropdownMenu>
        <a class="dropdown-item" (click)="reloadStudent()" title="Force reload this student">Reload Student</a>
        <a class="dropdown-item" (click)="expelStudent()" title="Expel this student">Expel Student</a>
      </div>
    </div>

    <div class="btn-group dropdown"
         *ngIf="!remoteUser.isGuest">
      <button
        type="button" class="button load-last-homework-button-panel"
        title="Show HW Report"
        (click)="showReport()"></button>
    </div>

    <div class="btn-group">
      <button
        class="button applause-button"
        [ngClass]="{'active': isApplauseSoundPlaying()}"
        title="Applause"
        (click)="playApplauseAudio()"></button>
    </div>

    <app-sticker-button
      *ngIf="!isOpenedFromList"
      [userListView]="isOpenedFromList"
      [remoteUser]="remoteUser"
      [userIndex]="userIndex"
      [studentsCount]="studentsCount">
    </app-sticker-button>

    <div class="btn-group">
      <button type="button" class="button star-button" title="Remove sticker" (click)="removeSticker()">-</button>
    </div>

    <div class="btn-group" *ngIf="!isOpenedFromList">
      <button type="submit" value="" class="button square fas fa-pencil-alt" title="Toggle whiteboard sharing"
              [ngStyle]="{'color': remoteUser.personalColor}"
              [disabled]="whiteboard.sharedUsers?.size === 0 || assignment.isLoaded"
              [class.on]="whiteboard.sharedUsers?.has(remoteUser.id) || whiteboard.sharedUsers?.size === 0"
              (click)="toggleWhiteboardSharing()">
      </button>
    </div>
    <div class="btn-group" *ngIf="!isOpenedFromList">
      <button type="submit"
              value=""
              class="button square fa-solid fa-right-left"
              title="Toggle assignment switch access"
              [disabled]="!assignment.isLoaded || assignment.allowedSwitchingUsers?.size === 0"
              [class.on]="assignment.allowedSwitchingUsers?.has(remoteUser.id) || (assignment.allowedSwitchingUsers && assignment.allowedSwitchingUsers.size === 0)"
              (click)="toggleAssignmentSwitchAccessWith()">
      </button>
    </div>

    <div class="btn-group" *ngIf="isOpenedFromList">
      <button title="Microphone on/off" class="button wrtc-subscriber-sound-btn fas fa-microphone" type="button"
              (click)="toggleAudioMute()"
              [disabled]="!remoteUser.additionalInfo.audio.isProvided"
              [ngClass]="{'wrtc-button-push audio-button-muted fa-microphone-slash': remoteUser.additionalInfo.audio.isMuted || !remoteUser.additionalInfo.audio.isProvided}">
      </button>
    </div>

    <div class="btn-group" *ngIf="isOpenedFromList">
      <button title="Camera on/off" class="button wrtc-subscriber-webcam-btn fas fa-video" type="button"
              [disabled]="!remoteUser.additionalInfo.video.isProvided"
              (click)="toggleVideoMute()"
              [ngClass]="{'wrtc-button-push video-button-muted fa-video-slash': remoteUser.additionalInfo.video.isMuted || !remoteUser.additionalInfo.video.isProvided}">
      </button>
    </div>
  </div>

  <div class="user-volume" *ngIf="!isOpenedFromList">
    <input type="range" class="form-control-range"
           name="volumeRange"
           title="Student volume"
           [disabled]="!remoteUser.additionalInfo.audio.isProvided || remoteUser.additionalInfo.audio.isMuted"
           (ngModelChange)="studentVoiceChangeHandler()"
           (mouseup)="sendStudentVoiceChangedEvent()"
           [(ngModel)]="remoteUser.additionalInfo.audio.voiceLevel"
           min="0" max="1" step="0.01">
  </div>
</ng-template>
